import * as actionTypes from './actionTypes';

export function updatePagination(currentPage,pageSize){
    return {
        type:actionTypes.UPDATE_PAGINATION,
        payload:{ currentPage,pageSize }
    }
}